import React from 'react';
import {CategoryViewType, ConfigApi} from "../../../../../../../../../../services/Api/types";
import ScrollMenuTo from "../../../../../../../../../../utils/ScrollMenuTo";
import StoreUtils from "../../../../../../../../../../services/Store/StoreUtils";
import AppConfig from "../../../../../../../../../../services/AppConfig";
import {MultistoreMenuCategory} from "../../../../../../../../utils/types";
import {
    ReactComponent as MenuItemDarkIco
} from "../../../../../../../../../../../images/icons/menus/menu-item-dark.svg";
import {ReactComponent as MenuItemIco} from "../../../../../../../../../../../images/icons/menus/menu-item.svg";
import {useTranslation} from "react-i18next";

interface Props {
    category: MultistoreMenuCategory;
    type: CategoryViewType;
    index: number;
    config: ConfigApi | undefined;
    menuId: number;
}

const MultistoreMenuCategoriesNavbarItem = ({category, type, index, config, menuId}: Props) => {
    const {t} = useTranslation();

    return (
        type === CategoryViewType.BASIC ? (
            <li className="nav-item">
                <ScrollMenuTo to={`category-${menuId}-${category.id}`} sectionMargin={48}
                              isFirstElement={index === 0}
                              productsViewType={StoreUtils.getMenuProductsViewType(config)}>
                    {category.name}
                </ScrollMenuTo>
            </li>
        ) : (
            <li className="nav-item nav-item-with-image">
                <ScrollMenuTo to={`category-${menuId}-${category.id}`} sectionMargin={48}
                              isFirstElement={index === 0}
                              productsViewType={StoreUtils.getMenuProductsViewType(config)}>
                    <div className="d-flex flex-column align-items-center gap-2">
                        <div className="card-img">
                            {
                                category.image ?
                                    <img src={category.image} alt={t("modules.menu.field.category_image.title")}/>
                                    : AppConfig.isDarkMode() ?
                                        <MenuItemDarkIco/> : <MenuItemIco/>
                            }
                        </div>
                        <p className="mb-0">{category.name}</p>
                    </div>
                </ScrollMenuTo>
            </li>
        )
    )
}

export default MultistoreMenuCategoriesNavbarItem;